import { Injectable, ViewContainerRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService as KendoNotificationService } from '@progress/kendo-angular-notification';
import { timer } from 'rxjs';

const NOTIFICATION_ANIMATION_DURATION_MS = 400;
const NOTIFICATION_DISPLAY_DURATION_MS = 7000;

@Injectable()
export class NotificationService {
  constructor(private notificationService: KendoNotificationService, private translateService: TranslateService) {}

  showNotification(
    message: string,
    style: 'none' | 'success' | 'warning' | 'error' | 'info',
    container: ViewContainerRef,
  ): void {
    const notification = this.notificationService.show({
      content: this.translateService.instant(message),
      cssClass: 'button-notification',
      animation: { type: 'slide', duration: NOTIFICATION_ANIMATION_DURATION_MS },
      position: { horizontal: 'center', vertical: 'top' },
      type: { style, icon: true },
      closable: true,
      appendTo: container,
    });
    timer(NOTIFICATION_DISPLAY_DURATION_MS).subscribe(() => {
      notification.hide();
    });
  }
}
